import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { X } from "lucide-react";

const rnd = () => Math.ceil(Math.random() * 9);

export function ContactUs({ className = "" }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", message: "", website: "" });
  const [captcha, setCaptcha] = useState("");
  const [nums, setNums] = useState({ a: rnd(), b: rnd() });
  const [sending, setSending] = useState(false);

  const reset = () => {
    setForm({ name: "", email: "", message: "", website: "" });
    setCaptcha("");
    setNums({ a: rnd(), b: rnd() });
  };

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", {
        name: form.name, email: form.email, message: form.message,
        website: form.website, num1: nums.a, num2: nums.b, captcha: Number(captcha),
      });
      toast.success("Thanks! Your message has been sent.");
      setOpen(false); reset();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not send your message. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <button
        type="button"
        data-testid="footer-contact"
        onClick={() => setOpen(true)}
        className={className || "font-semibold underline"}
      >
        Contact Us
      </button>

      {open && (
        <div className="fixed inset-0 z-[100] grid place-items-center bg-black/50 p-4" onClick={() => setOpen(false)}>
          <div className="nb-card bg-[#FDFBF7] w-full max-w-md p-6 relative" onClick={(e) => e.stopPropagation()}>
            <button type="button" onClick={() => setOpen(false)} aria-label="Close"
              className="absolute top-3 right-3 w-9 h-9 grid place-items-center rounded-xl border-2 border-[#0A0A0A] bg-white hover:bg-[#FFD5CC]">
              <X className="w-4 h-4" />
            </button>
            <h2 className="text-2xl font-display font-bold">Contact Us</h2>
            <p className="text-sm text-[#4A4A4A] mt-1 mb-4">Send us a message and we'll get back to you by email.</p>

            <form onSubmit={submit} className="grid gap-3">
              <input required data-testid="contact-name" placeholder="Your name" value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="w-full px-4 py-2.5 rounded-xl border-2 border-[#0A0A0A] bg-white focus:outline-none focus:ring-2 focus:ring-[#C8B6FF]" />
              <input required type="email" data-testid="contact-email" placeholder="Your email" value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full px-4 py-2.5 rounded-xl border-2 border-[#0A0A0A] bg-white focus:outline-none focus:ring-2 focus:ring-[#C8B6FF]" />
              <textarea required rows={4} data-testid="contact-message" placeholder="How can we help?" value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                className="w-full px-4 py-2.5 rounded-xl border-2 border-[#0A0A0A] bg-white resize-none focus:outline-none focus:ring-2 focus:ring-[#C8B6FF]" />

              {/* honeypot — hidden from humans, bots tend to fill it */}
              <input type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" value={form.website}
                onChange={(e) => setForm({ ...form, website: e.target.value })}
                style={{ position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0 }} />

              <label className="flex items-center gap-3 text-sm font-semibold">
                Anti-spam: what is {nums.a} + {nums.b}?
                <input required type="number" data-testid="contact-captcha" value={captcha}
                  onChange={(e) => setCaptcha(e.target.value)}
                  className="w-20 px-3 py-2 rounded-xl border-2 border-[#0A0A0A] bg-white focus:outline-none focus:ring-2 focus:ring-[#C8B6FF]" />
              </label>

              <button type="submit" disabled={sending} data-testid="contact-submit"
                className="nb-btn bg-[#C8B6FF] px-5 py-2.5 justify-center disabled:opacity-60">
                {sending ? "Sending…" : "Send message"}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
